import React from 'react';
import PageCharacterLink from './PageCharacterLink';
import { remCalc } from '../../util/style-util';
import { darkGray, lightGray } from '../../styles/style-constants';
import { makeStyles } from '@mui/styles';

type Props = {
  title: string;
  characters: {
    character: string;
    characterType: string;
    pageNumber: number | number[];
  }[];
  color: string;
  closeMenu: () => void;
  showBottomBorder: boolean;
  multiColumn: boolean;
  isCursive: boolean;
  hasIcon: boolean;
};

const useStyles = makeStyles(() => ({
  pageCategory: (props: any) => ({
    borderBottom: props.showBottomBorder && `1px solid ${lightGray}`,
    paddingBottom: 20,
    textAlign: props.multiColumn ? 'left' : 'center'
  }),
  categoryTitle: {
    fontSize: remCalc(16),
    color: darkGray,
    marginBottom: remCalc(24),
    whiteSpace: 'nowrap'
  },
  categoryCharacters: (props: any) => ({
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: props.multiColumn ? 'flex-start' : 'center',
    fontFamily: props.isCursive ? 'GSS Cursive Beginner Book' : 'inherit'
  })
}));

const PageCategory = ({
  title,
  characters,
  color,
  closeMenu,
  showBottomBorder,
  multiColumn,
  isCursive,
  hasIcon
}: Props) => {
  const classes = useStyles({ multiColumn, showBottomBorder, isCursive });

  return (
    <li className={classes.pageCategory}>
      {title && <h3 className={classes.categoryTitle}>{title}</h3>}
      <div className={classes.categoryCharacters}>
        {characters.map(symbol => (
          <PageCharacterLink
            color={color}
            handleClick={closeMenu}
            key={symbol.character}
            symbol={symbol}
            closeMenu={closeMenu}
            noLeftSpacing={multiColumn}
            useFlex={false}
            hasIcon={hasIcon}
          />
        ))}
      </div>
    </li>
  );
};

export default PageCategory;
